const NavEditCompleted = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
  >
    <mask
      id="mask0_827_40483"
      style={{ maskType: "alpha" }}
      width="24"
      height="24"
      x="0"
      y="0"
      maskUnits="userSpaceOnUse"
    >
      <path fill="#D9D9D9" d="M0 0H24V24H0z"></path>
    </mask>
    <g mask="url(#mask0_827_40483)">
      <path
        fill="#88BEEB"
        d="M12 22a9.738 9.738 0 01-3.9-.788 10.099 10.099 0 01-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 012 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 012.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0112 2c1.083 0 2.108.158 3.075.475.967.317 1.858.758 2.675 1.325L16.3 5.275a8.6 8.6 0 00-2.025-.938A7.552 7.552 0 0012 4c-2.217 0-4.104.78-5.662 2.338C4.779 7.896 4 9.783 4 12s.78 4.104 2.338 5.663C7.896 19.22 9.783 20 12 20s4.104-.78 5.663-2.337C19.22 16.104 20 14.217 20 12c0-.3-.017-.6-.05-.9a7.356 7.356 0 00-.15-.875L21.425 8.6c.183.533.325 1.083.425 1.65.1.567.15 1.15.15 1.75a9.738 9.738 0 01-.788 3.9 10.098 10.098 0 01-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0112 22zm-1.4-5.4l-4.25-4.25 1.4-1.4 2.85 2.85 10-10.025 1.4 1.4L10.6 16.6z"
      ></path>
    </g>
  </svg>
);

export default NavEditCompleted;
